import {ReactComponent as Logo} from '../../assets/images/logoAnimated.svg'

export const Home = () => <>
    <Logo />
   <h2>Западная группа поддержки</h2>
  <h1>Московские Ястребы</h1>
</>

